/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import config from "../../config/config";
import { useSelector } from 'react-redux';
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../constants";
import axios from "axios";
import "./O2CMainComp.css";
import styles from "./O2CMainComp.module.css";
// import PercentageIndicator from "../../atomicComponents/PercentageIndicator/PercentageIndicator";
import PercentageIndicatorNew from "../../atomicComponents/PercentageIndicator/PercentageIndicatorNew";
import DetailedDomainTile from "../../atomicComponents/DetailedDomainTile/DetailedDomainTile";
import O2CDashboardSection from "./O2CDashboardSection";
import HorizentalTileCardDual from "../ProcureToPayComp/DualCircleCards/HorizentalCard";
import TileCardDual from "../ProcureToPayComp/DualCircleCards/TileCardsDual";
import WithOutPercentageIndicator from "../../atomicComponents/PercentageIndicator/withoutIndicator";


const { API_BASE_URL } = config;

function O2CMainComp() {

  const quarterOptionss = [
    { value: "2", label: "Q1" },
    { value: "3", label: "Q2" },
    { value: "4", label: "Q3" },
    { value: "1", label: "Q4" },
  ];

  const quarterToMonths = {
    2: [4, 5, 6],  // Apr–Jun
    3: [7, 8, 9],  // Jul–Sep
    4: [10, 11, 12], // Oct–Dec
    1: [1, 2, 3]   // Jan–Mar
  };

  const allMonths = [
    { label: 'Jan', value: 1 },
    { label: 'Feb', value: 2 },
    { label: 'Mar', value: 3 },
    { label: 'Apr', value: 4 },
    { label: 'May', value: 5 },
    { label: 'Jun', value: 6 },
    { label: 'Jul', value: 7 },
    { label: 'Aug', value: 8 },
    { label: 'Sep', value: 9 },
    { label: 'Oct', value: 10 },
    { label: 'Nov', value: 11 },
    { label: 'Dec', value: 12 },
  ];

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const { showPopup } = usePopupManager();

  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    quarterData: [],
    monthData: [],
  };

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState(allMonths);
  const [quarterOptions, setQuarterOptions] = useState(quarterOptionss);

  const [salesData, setSalesData] = useState({});
  const [dispatchSalesOrderData, setDispatchSalesOrderData] = useState({});
  const [dispatchPlantPartData, setDispatchPlantPartData] = useState({});
  const [dispatchData, setDispatchData] = useState({});
  const [dispatchMVData, setDispatchMVData] = useState({});
  const [afterSalesClaimsData, setAfterSalesClaimsData] = useState({});
  const [afterSalesAMCData, setAfterSalesAMCData] = useState({});
  const [afterSalesData, setAfterSalesData] = useState({});

  const [entity, setEntity] = useState(null);
  const [year, setYear] = useState(null);
  const [quarter, setQuarter] = useState([]);
  const [month, setMonth] = useState([]);

  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleQuarterChange = (selected) => {
    if (selected && selected.length > 0) {
      setQuarter(selected);
      setFilters(prev => ({ ...prev, quarterData: selected }));
      const selectedMonths = selected.flatMap(q => quarterToMonths[q.value]);
      const updatedMonths = monthOptions.filter(m => selectedMonths.includes(m.value));
      setMonth(updatedMonths);
      setFilters(prev => ({ ...prev, monthData: updatedMonths }));
    } else {
      setQuarter([]);
      setMonth([]);
      setFilters(prev => ({ ...prev, quarterData: [], monthData: [] }));
    }
  };

  const handleMonthChange = (selected) => {
    const updatedMonths = selected || [];
    setMonth(updatedMonths);
    setFilters(prev => ({ ...prev, monthData: updatedMonths }));
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '20px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '50px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const handleApply = () => {
    const entityFilterData = entity?.value || '';
    const yearFilterData = year?.value || '';
    const monthFilterData = month?.map(m => m?.value) || [];
    const quarterData = quarter?.map(q => q?.value) || [];

    if (entityFilterData === '') {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    if (yearFilterData === '') {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select Fiscal year.",
      });
      return;
    }

    setIsLoading(true);

    const fetchSalesData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-sales`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            setSalesData(result)
          })
      } catch (error) {
        console.error('Error fetching Sales Data options:', error);
      }
    };

    const fetchDispatchSalesOrderData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-dispatch-salesorder`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            setDispatchSalesOrderData(result[0])
          })
      } catch (error) {
        console.error('Error fetching Dispatch Sales Order Data options:', error);
      }
    };

    const fetchDispatchPlantPartData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-dispatch-plantpart`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            setDispatchPlantPartData(result[0])
          })
      } catch (error) {
        console.error('Error fetching Dispatch Plant Part Data options:', error);
      }
    };

    const fetchDispatchData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-dispatch`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            setDispatchData(result)
          })
      } catch (error) {
        console.error('Error fetching Dispatch Data Transport Billing options:', error);
      }
    };

    const fetchDispatchMVData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-dispatch-mv`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            setDispatchMVData(result)
          })
      } catch (error) {
        console.error('Error fetching Dispatch Data MV Insurance options:', error);
      }
    };

    const fetchAfterSalesClaimsData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-aftersales-claims`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            setAfterSalesClaimsData(result[0])
          })
      } catch (error) {
        console.error('Error fetching After Sales Claims Maindashboard Data options:', error);
      }
    };

    const fetchAfterSalesAMCData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-aftersales-amc`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            setAfterSalesAMCData(result[0])
          })
      } catch (error) {
        console.error('Error fetching After Sales AMC Bookings Data options:', error);
      }
    };

    const fetchAfterSalesData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/O2C-aftersales`,
          {
            selectedEntity: entityFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
            selectedQuarter: quarterData,
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            }
          },
        )
          .then((response) => {
            const result = response.data;
            setAfterSalesData(result)
          })
      } catch (error) {
        console.error('Error fetching After Sales Data options:', error);
      }
    };

    Promise.all([fetchSalesData(), fetchDispatchSalesOrderData(), fetchDispatchPlantPartData(), fetchDispatchMVData(),fetchDispatchData(), fetchAfterSalesClaimsData(), fetchAfterSalesAMCData(), fetchAfterSalesData()]).then(() => {
      setShowDashboard(true);
      setIsLoading(false);
    });
  };

  const handleReset = () => {
    setEntity(null);
    setYear(null);
    setQuarter([]);
    setMonth([]);
    setFilters({
      entityData: null,
      yearData: null,
      quarterData: [],
      monthData: [],
    });
    setShowDashboard(false);
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/O2C-entity`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setEntityOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching O2C-entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/O2C-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setYearOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching O2C-year options:', error);
    }
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
  }, []);

  useEffect(() => {

    if (entityOptions.length && quarterOptions.length && yearOptions.length && monthOptions.length) {

      if (filters.entityData?.value) {
        const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
        if (ent) setEntity(ent);
      }

      if (filters.yearData?.value) {
        const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
        if (yr) setYear(yr);
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptions.filter(opt =>
          filters.monthData.some(m => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }

      if (filters.quarterData && filters.quarterData.length > 0) {
        const qtr = quarterOptions.filter(opt =>
          filters.quarterData.some(q => q.value === opt.value)
        );
        if (qtr.length > 0) setQuarter(qtr);
      }

      if (filters.entityData?.value) {
        setTimeout(() => {
          setHasApplied(true);
        }, 1000);
      }
    }
  }, [entityOptions, yearOptions, quarterOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
              // isMulti={true}
              // closeMenuOnSelect={false}
              styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Fiscal Year<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={true}
              // isMulti={true}
              // closeMenuOnSelect={false}
              styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                onChange={handleQuarterChange}
                options={quarterOptionss}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>

      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
          </div>
        </div>
      )}
      {showDashboard && (
        <>
          <div className="row">
            <div className="col-lg-12">
              <div>
                <DetailedDomainTile
                  title="Sales"
                  showButton={true}
                  path="/Order-To-Cash/Sales"
                  detailState={filters}
                   infoIcondata={"Manual CSV DATA"}
                />
              </div>
              <div className="dashboardnew">
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <div className="section-box">
                      <div className="header-row">
                        <div></div>
                        <div className="header-box-o2c">Timeliness</div>
                        <div className="header-box-o2c">Accuracy</div>
                      </div>
                      <div className="data-row">
                        <div className="label">Credit Control</div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["CREDITCONTROL"]?.timeliness ?? "NA"}
                            activeIndex={salesData["CREDITCONTROL"]?.timeliness >= 90 ? 1 : salesData["CREDITCONTROL"]?.timeliness >= 80 ? 2 : 3}
                          />
                        </div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["CREDITCONTROL"]?.accuracy ?? "NA"}
                            activeIndex={salesData["CREDITCONTROL"]?.accuracy >= 90 ? 1 : salesData["CREDITCONTROL"]?.accuracy >= 80 ? 2 : 3}
                          />
                        </div>
                      </div>
                      <div className="data-row">
                        <div className="label">AR Activities</div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["ARActivities"]?.timeliness ?? "NA"}
                            activeIndex={salesData["ARActivities"]?.timeliness >= 90 ? 1 : salesData["ARActivities"]?.timeliness >= 80 ? 2 : 3}
                          />
                        </div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["ARActivities"]?.accuracy ?? "NA"}
                            activeIndex={salesData["ARActivities"]?.accuracy >= 90 ? 1 : salesData["ARActivities"]?.accuracy >= 80 ? 2 : 3}
                          />
                        </div>
                      </div>
                      <div className="data-row">
                        <div className="label">FME Validation</div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["FMEValidation?"]?.timeliness ?? "NA"}
                            activeIndex={salesData["FMEValidation?"]?.timeliness >= 90 ? 1 : salesData["FMEValidation?"]?.timeliness >= 80 ? 2 : 3}
                          />
                        </div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["FMEValidation?"]?.accuracy ?? "NA"}
                            activeIndex={salesData["FMEValidation?"]?.accuracy >= 90 ? 1 : salesData["FMEValidation?"]?.accuracy >= 80 ? 2 : 3}
                          />
                        </div>
                      </div>
                      <div className="data-row">
                        <div className="label">VME Validation</div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["VMEValidation"]?.timeliness ?? "NA"}
                            activeIndex={salesData["VMEValidation"]?.timeliness >= 90 ? 1 : salesData["VMEValidation"]?.timeliness >= 80 ? 2 : 3}
                          />
                        </div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["VMEValidation"]?.accuracy ?? "NA"}
                            activeIndex={salesData["VMEValidation"]?.accuracy >= 90 ? 1 : salesData["VMEValidation"]?.accuracy >= 80 ? 2 : 3}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="section-box">
                      <div className="header-row">
                        <div></div>
                        <div className="header-box-o2c">Timeliness</div>
                        <div className="header-box-o2c">Accuracy</div>
                      </div>
                      <div className="data-row-right">
                        <div className="label">Internal Billing</div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["INTERNALBILLING"]?.timeliness ?? "NA"}
                            activeIndex={salesData["INTERNALBILLING"]?.timeliness >= 90 ? 1 : salesData["INTERNALBILLING"]?.timeliness >= 80 ? 2 : 3}
                          />
                        </div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["INTERNALBILLING"]?.accuracy ?? "NA"}
                            activeIndex={salesData["INTERNALBILLING"]?.accuracy >= 90 ? 1 : salesData["INTERNALBILLING"]?.accuracy >= 80 ? 2 : 3}
                          />
                        </div>
                      </div>
                      <div className="data-row-right">
                        <div className="label">Plant Receivable</div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["Plant?Receivables"]?.timeliness ?? "NA"}
                            activeIndex={salesData["Plant?Receivables"]?.timeliness >= 90 ? 1 : salesData["Plant?Receivables"]?.timeliness >= 80 ? 2 : 3}
                          />
                        </div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["Plant?Receivables"]?.accuracy ?? "NA"}
                            activeIndex={salesData["Plant?Receivables"]?.accuracy >= 90 ? 1 : salesData["Plant?Receivables"]?.accuracy >= 80 ? 2 : 3}
                          />
                        </div>
                      </div>
                      <div className="data-row-right">
                        <div className="label">AMC & FMS Invoice Settlement</div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["AMC and FMS Invoice Validation & Settlement"]?.timeliness ?? "NA"}
                            activeIndex={salesData["AMC and FMS Invoice Validation & Settlement"]?.timeliness >= 90 ? 1 : salesData["AMC and FMS Invoice Validation & Settlement"]?.timeliness >= 80 ? 2 : 3}
                          />
                        </div>
                        <div className="cellnew">
                          <PercentageIndicatorNew
                            percentage={salesData["AMC and FMS Invoice Validation & Settlement"]?.accuracy ?? "NA"}
                            activeIndex={salesData["AMC and FMS Invoice Validation & Settlement"]?.accuracy >= 90 ? 1 : salesData["AMC and FMS Invoice Validation & Settlement"]?.accuracy >= 80 ? 2 : 3}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div>
                <DetailedDomainTile
                  title="Dispatch"
                  showButton={true}
                  path="/Order-To-Cash/Dispatch-and-Billing"
                  detailState={filters}
                  infoIcondata={"Manual CSV + SAP DATA"}
                />
              </div>
              <div className="section-box">
                <div className="row g-3" style={{ paddingBottom: "10px" }}>
                  <div className="header-row-new">
                    <div></div>
                    {/* <div>Actual Value</div>
                    <div>Yearly Rolling Average</div> */}
                    <div className="header-box-o2c">Actual Value</div>
                    <div className="header-box-o2c">Yearly Rolling Average</div>
                  </div>
                  <div className="data-row-new">
                    <div className="label-new">Sales Order Created</div>
                    <div className="cellnew-new">
                      <WithOutPercentageIndicator
                        percentage={dispatchSalesOrderData.actual_value ?? "NA"}
                      />
                    </div>
                    <div className="cellnew-new">
                      <WithOutPercentageIndicator
                        percentage={dispatchSalesOrderData.yearly_rolling_average ?? "NA"}
                      />
                    </div>
                  </div>
                  <div className="data-row-new">
                    <div className="label-new">Plant Part Dispatch Invoices Created</div>
                    <div className="cellnew">
                      <WithOutPercentageIndicator
                        percentage={dispatchPlantPartData.actual_value ?? "NA"}
                      />
                    </div>
                    <div className="cellnew">
                      <WithOutPercentageIndicator
                        percentage={dispatchPlantPartData.yearly_rolling_average ?? "NA"}
                      />
                    </div>
                  </div>
                </div>
                <div className="row g-3 p-1">
                  <div className="col-md-6 col-sm-12 d-flex flex-column gap-3">
                    <HorizentalTileCardDual
                      title="Transporter Bill Processing"
                      timeliness={dispatchData["Transporter Billing processsing"]?.timeliness ?? "NA"}
                      accuracy={dispatchData["Transporter Billing processsing"]?.accuracy ?? "NA"}
                      color1="#800080"
                      color2="#21cf21"
                    />
                  </div>
                  <div className="col-md-6 col-sm-12 d-flex flex-column gap-3">
                    <HorizentalTileCardDual
                      title="Insurance Claims Validation(MV)"
                      timeliness={dispatchMVData["Insurance claim Management"]?.timeliness ?? "NA"}
                      accuracy={dispatchMVData["Insurance claim Management"]?.accuracy ?? "NA"}
                      color1="#800080"
                      color2="#21cf21"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div>
                <DetailedDomainTile
                  title="After Sales"
                  showButton={true}
                  path="/Order-To-Cash/After-Sales"
                  detailState={filters}
                  infoIcondata={"Manual CSV + SAP DATA"}
                />
              </div>
              <div className="section-box">
                <div className="row" style={{padding:"32px"}}>
                  <div className="col-md-7 col-sm-12 d-flex flex-column gap-4">
                    <HorizentalTileCardDual
                      title="Claim Management"
                      timeliness={afterSalesClaimsData?.timeliness ?? "NA"}
                      accuracy={afterSalesClaimsData?.accuracy ?? "NA"}
                      color1="#800080"
                      color2="#21cf21"
                    />
                    <HorizentalTileCardDual
                      title="AMC Bookings"
                      timeliness={afterSalesAMCData?.avg_timeliness ?? "NA"}
                      accuracy={afterSalesAMCData?.avg_accuracy ?? "NA"}
                      color1="#800080"
                      color2="#21cf21"
                    />
                    </div>
                    <div className="col-md-5 col-sm-12 d-flex align-items-start justify-content-between gap-2">
                      <TileCardDual
                        title="Blocking/ Unblocking of Customer Code"
                        timeliness={afterSalesData["Blocking/ Unblocking of Customer Code"]?.timeliness ?? "NA"}
                        accuracy={afterSalesData["Blocking/ Unblocking of Customer Code"]?.accuracy ?? "NA"}
                        color1="#800080"
                        color2="#21cf21"
                      />
                    </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default O2CMainComp;